import { SingleSelectField } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { ContactStatus, allContactStatus } from "../shared/types";

interface Props {
	name: string;
	label: string;
}

export const ContactStatusSingleSelect: FC<Props> = ({ name, label }) => {
	const { t } = useTranslation();

	return (
		<SingleSelectField<string, ContactStatus>
			name={name}
			label={label}
			options={allContactStatus}
			getLabel={(o) => t(o)}
			getValue={String}
		/>
	);
};
